import { useMemo } from 'react';

import { useCookiesConsentManagerContext } from '@pflegia/ui/contexts/cookies-consent-manager.context';
import { cookieStorage } from '@pflegia/ui/storage/cookie-storage';

const useIsAdvertisingAllowed = () => {
  const { ready, cookiesSettings } = useCookiesConsentManagerContext();
  return useMemo(
    () => JSON.parse(cookieStorage.getItem('tracking-preferences') || '{}').custom?.advertising || (ready && cookiesSettings.advertising),
    [ready, cookiesSettings.advertising],
  );
};

export default useIsAdvertisingAllowed;
